// GENERATED FILE - do not edit.
// Emitted by tools/generate-wire-schemas.mjs from
// Server/src/Shared/Server/Resources/openapi.json (the spec lockfile).
// Regenerate with: npm run generate:wire
//
// Base wire shape for the server "SnippetUpdateDto" component. The corresponding
// *.schema.ts is the facade that names it (and hosts any future refinement);
// see design/wiki/wire-schemas.md.
import { z } from "zod";

export const SnippetUpdateDtoGenShape = z.strictObject({
  description: z.string(),
  keywords: z.string(),
  localisationHint: z.string(),
  data: z.string(),
  tags: z.array(z.string()),
});
